import React from 'react';
import styled from 'styled-components';

interface BoardContainerProps {
  children: React.ReactNode;
}

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
`;

const BoardContainer: React.FC<BoardContainerProps> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default BoardContainer; 